export default __webpack_public_path__ + "static/media/theapplepan.9f2affc0.png";